var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M355.85-385.33q-22.18 0-37.35-15.32-15.17-15.32-15.17-37.5t15.32-37.35q15.32-15.17 37.5-15.17t37.35 15.32q15.17 15.32 15.17 37.5t-15.32 37.35q-15.32 15.17-37.5 15.17Zm248.67 0q-22.19 0-37.35-15.32Q552-415.97 552-438.15t15.32-37.35q15.31-15.17 37.5-15.17 22.18 0 37.35 15.32 15.16 15.32 15.16 37.5t-15.31 37.35q-15.32 15.17-37.5 15.17ZM480-146.67q139.58 0 236.46-96.96 96.87-96.97 96.87-236.68 0-25.02-3.66-49.19-3.67-24.17-10.34-45.17-20.33 5-42.84 7.17-22.51 2.17-47.16 2.17-95.07 0-179.7-39.67t-144.3-112.33q-33.33 80-95.5 139.5-62.16 59.5-143.16 91.16v6.67q0 139.58 96.87 236.46 96.88 96.87 236.46 96.87ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-79.33-723Q473.33-711 547-671.5 620.67-632 709.33-632q20.67 0 34.34-1.17 13.66-1.16 29.66-5.16-44-77.34-119.66-126.17Q578-813.33 480-813.33q-22.67 0-43 3.16-20.33 3.17-36.33 7.17ZM158.33-565.67q49-21.66 102.67-79.33t77.33-136.67Q263.33-746 221-690.33q-42.33 55.66-62.67 124.66ZM400.67-803Zm-62.34 21.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.00d0d48ea203cbff028102a28d7675a0.svg";
export { ForwardRef as ReactComponent };